// extracted by mini-css-extract-plugin
module.exports = {"container":"AsianAddressForm_container__QZYit","addressFields":"AsianAddressForm_addressFields__jpVfl"};